export default __webpack_public_path__ + "532809d03f9babeb47add30dbc0ef1d0.svg";